<template>
    <div class="backoffice-subscriptions-view">
        <div class="page-header">
            <div class="left">
                <h3 class="title">{{ subscription.name }}</h3>
            </div>
            <div class="right">
                <v-btn color="primary" dark @click="editModal = true">
                    <v-icon small>mdi-pencil</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp">{{ $page.props.lang.edit || "Edit" }}</span>
                </v-btn>
                <v-btn v-if="member_count === 0" color="primary" dark @click="deleteModal = true">
                    <v-icon small >mdi-delete</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp">{{ $page.props.lang.delete || "Delete" }}</span>
                </v-btn>
                <v-btn v-if="subscription.is_archived == 0" color="primary" dark @click="showArchiveModal = true">
                    <v-icon small>mdi-archive-arrow-down-outline</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp">{{ $page.props.lang.archive || "Archive" }}</span>
                </v-btn>
                <v-btn v-else color="primary" dark @click="archive">
                    <v-icon small>mdi-archive-arrow-up-outline</v-icon>
                    <span v-if="$vuetify.breakpoint.mdAndUp">{{ $page.props.lang.unarchive || "Unarchive" }}</span>
                </v-btn>
            </div>
            <v-dialog v-model="editModal" max-width="500px">
            <v-card>
                <div class="modal-header">
                    <h4 class="modal-headline">{{ $page.props.lang.editMembership || "Edit membership" }}</h4>
                    <div class="tools">
                        <v-btn icon @click="editModal = false"><v-icon>mdi-close</v-icon></v-btn>
                    </div>
                </div>
                <v-card-text>
                    <v-container>
                        <v-row>
                             <v-col cols="12">
                                <p class="custom-label">{{$page.props.lang.sku || 'SKU'}}</p>
                                <v-text-field v-model="editedSub.sku" 
                                    :error-messages="responseErrors.sku" @focus="responseErrors.sku=''" 
                                    outlined dense :hide-details="!responseErrors.sku"></v-text-field>
                             </v-col>
                            <v-col cols="12">
                                <p class="custom-label">{{$page.props.lang.form_name|| 'Name'}}</p>
                                <v-text-field v-model="editedSub.name" 
                                    :error-messages="responseErrors.name" @focus="responseErrors.name=''" 
                                    outlined dense :hide-details="!responseErrors.name"></v-text-field>
                             </v-col>
                             <v-col cols="6">
                                <v-switch class="mt-0 pt-0" v-model="editedSub.is_limited" 
                                :label="$page.props.lang.limit_class|| 'Limit Class Access'" hide-details>
                                </v-switch>
                             </v-col>  
                             <v-col cols="12" v-if="editedSub.is_limited">
                                <p class="custom-label">{{$page.props.lang.allow_booking_for_classes || 'Allow booking for selected classes:'}}</p>
                                <v-select v-model="editedSub.courses" 
                                :items="courses" 
                                item-value="id"
                                item-text="title"
                                multiple
                                :error-messages="responseErrors.courses" @change="responseErrors.courses=''" 
                                class="period-select" outlined dense :hide-details="!responseErrors.courses"></v-select>
                             </v-col>    
                             <v-col cols="12">
                                <p class="custom-label">{{$page.props.lang.form_description || 'Description' }}</p>
                                <v-textarea v-model="editedSub.description" 
                                    :error-messages="responseErrors.description" @focus="responseErrors.description=''" 
                                    rows="2" outlined dense :hide-details="!responseErrors.description"></v-textarea>
                            </v-col>
                            <v-col cols="12">
                                <p class="custom-label">{{ $page.props.lang.table_period || 'Period between each customer payment' }}</p>
                                <v-row>
                                    <v-col cols="4">
                                        <v-text-field v-model="editedSub.period_value" 
                                            :error-messages="responseErrors.period_value" @focus="responseErrors.period_value=''" 
                                            outlined dense :hide-details="!responseErrors.period_value"></v-text-field>
                                    </v-col>
                                    <v-col cols="8">
                                        <v-select v-model="editedSub.period_name" 
                                            :items="periodNameSelect"
                                            :error-messages="responseErrors.period_name" @change="responseErrors.period_name=''" 
                                            class="period-select" outlined dense :hide-details="!responseErrors.period_name"></v-select>
                                    </v-col>  
                                </v-row>
                            </v-col>
                             <v-col cols="12"> 
                                <p class="custom-label">{{ $page.props.lang.membership_count || 'How many TIMES should the customer be charged?' }}</p>
                                <v-select v-model="editedSub.count" 
                                            :items="membershipCount" 
                                            :error-messages="responseErrors.count" @change="responseErrors.count=''" 
                                            class="period-select" outlined dense :hide-details="!responseErrors.count"></v-select>
                            </v-col> 
                            <v-col cols="12">
                                <p class="custom-label">{{ $page.props.lang.form_limit || 'Number of visits' }}</p>
                                <v-text-field v-model="editedSub.limit" outlined dense
                                :error-messages="responseErrors.limit" @focus="responseErrors.limit=''"
                                :hide-details="!responseErrors.limit"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="editModal = false" color="regular">{{ $page.props.lang.cancel || "Cancel" }}</v-btn>
                            <v-btn @click="editSubscription" color="primary">{{ $page.props.lang.save || "Save" }}</v-btn>
                        </v-card-actions>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        </div>
        <v-row v-if="$page.props.p['reports']"> 
                <v-col cols="12" sm="6" md="3"> 
                    <v-card elevation="1" class="box">
                        <v-card-title>{{ $page.props.lang.membership_duration || "Duration" }}</v-card-title>
                        <v-row>
                            <v-col cols="4">
                                <v-avatar size="50" tile class="pb-3">
                                    <v-icon>mdi-clock-outline</v-icon>
                                </v-avatar>
                            </v-col>
                            <v-col cols="8">
                                <h2 class="value2">{{ subscription.period_value }} {{ period_name }}</h2>
                            </v-col>
                        </v-row>                   
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-card elevation="1" class="box">
                        <v-card-title>{{ $page.props.lang.membership_renewing || "Renewing" }}</v-card-title>
                        <v-row>
                            <v-col cols="4">
                                <v-avatar size="50" tile class="pb-3">
                                    <v-icon>mdi-autorenew</v-icon>
                                </v-avatar>
                            </v-col>
                            <v-col cols="8">
                                <h2 v-if="subscription.count !== 0" class="value"> {{ subscription.count }}</h2>
                                <h2 v-else class="value2">{{ $page.props.lang.until_canceled || "Until canceled" }}</h2>
                            </v-col>
                        </v-row>                     
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-card elevation="1" class="box">
                        <v-card-title>{{ $page.props.lang.renewing_price || "Renewing price" }}</v-card-title>
                        <v-row>
                            <v-col cols="4">
                               <v-avatar size="50" tile>
                                    {{$page.props.organization.settings.currency}}
                                </v-avatar>
                            </v-col>
                            <v-col cols="8">
                                <h2 class="value2"> {{ subscription.price }}</h2>
                            </v-col>
                        </v-row>                     
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-card elevation="1" class="box">
                        <v-card-title>{{ $page.props.lang.visits || "Visits Available" }}</v-card-title>
                        <v-row>
                            <v-col cols="4">   
                                <v-avatar size="50" tile class="pb-3">
                                    <v-icon>mdi-check-all</v-icon>
                                </v-avatar>
                            </v-col>
                            <v-col cols="8">
                                <h2 v-if="subscription.limit" class="value2">{{ subscription.limit }}</h2>
                                <h2 v-else class="value2">{{ $page.props.lang.unlimited || "Unlimited" }}</h2>
                            </v-col>
                        </v-row>                     
                    </v-card>
                </v-col>
                <v-col cols="12" sm="6" md="3">
                    <v-card elevation="1" class="box">
                        <v-card-title>{{ $page.props.lang.available_courses || "Available Courses" }}</v-card-title>
                        <v-row v-if="subscription.courses.length == 0">
                            <v-col cols="4" class="text-left">   
                                <v-avatar size="50" tile class="pb-3">
                                    <v-icon class="mr-5">mdi-dumbbell</v-icon>
                                </v-avatar>
                            </v-col>
                            <v-col cols="8">
                                <h2 class="value2">{{ $page.props.lang.available_courses_all || "All" }}</h2>
                            </v-col>
                        </v-row>
                        <v-row v-else>
                            <v-col cols="12" class="text-right">
                                <v-list>
                                    <v-list-group
                                     no-action
                                     prepend-icon="mdi-dumbbell"
                                     sub-group
                                    >
                                        <template v-slot:activator>
                                            <v-list-item-content>
                                                <v-list-item-title class="show-btn text-right">{{ $page.props.lang.show_courses || "Show" }}<v-icon color="primary">mdi-chevron-down</v-icon></v-list-item-title>
                                            </v-list-item-content>
                                        </template>
                                        <v-list-item v-for="item in subscription.courses" :key="item.id">
                                            <v-list-item-content>
                                                <v-list-item-title :style="{color:item.course.color}" class="list-item" v-text="item.course.title"></v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list-group>
                                </v-list>
                            </v-col>
                        </v-row>                     
                    </v-card>
                </v-col>
            </v-row>
            <p class="mt-15 font-weight-medium">{{ $page.props.lang.title_description || 'Membership Description' }}</p>
            <p class="mt-5 ml-5" v-if="subscription.description"> {{ subscription.description }}</p> 
            <p class="mt-5 ml-5" v-else>{{ $page.props.lang.no_description || "Membership does not have a description!" }}</p>

            <ConfirmModal :open="showArchiveModal"
                @no="showArchiveModal = false" 
                @yes="archive" 
                @close="showArchiveModal = false"
                :title="$page.props.lang.archiveConfirmTitle || 'Archive confirmation'"
                :description="$page.props.lang.archiveConfirmDesc || 'You will not be able to assign an archived memebrship to your members. All members who have this membership fee will be able to use it until it expires. <br /> <br /> Are You sure You want to archive this subscription?'">
            </ConfirmModal>
            <ConfirmModal :open="deleteModal"
                @no="deleteModal = false" 
                @yes="deleteSubscription" 
                @close="deleteModal = false"
                :title="$page.props.lang.deleteConfirmation || 'Delete confirmation'"
                :description="$page.props.lang.deleteConfirmDesc || 'Are You sure You want to delete this subscription?'">
            </ConfirmModal>
    </div>
</template>
<style scoped>
    .show-btn{
        font-size: 1.2rem;
        font-weight: 500;
        color: #971D61;
    }
    .list-item{
        font-size: 1rem;
        font-weight: 500;
    }
</style>
<script>
import AppLayout from '@/js/Layouts/AppLayout'
import ConfirmDelete from '@/js/Components/ConfirmDelete'
import ConfirmModal from '@/js/Components/ConfirmModal'
import EventBus from '@/js/eventbus'

export default {
    metaInfo() {
        return {
            title: this.$page.props.lang.pageTitle || "Subscription details"
        }
    },
    layout: AppLayout,
    components: {
        ConfirmDelete,
        ConfirmModal
    },
    props: {
        subscription: Object,
        courses_ids: Array,
        period_name: String,
        lang: Object,
        member_count: Number,
        courses: Array
    },
    data() {
        return {
            // courses_ids: this.courses_id,
            coursesData: this.subscription.courses,
            subscriptionReset: this.subscription,
            messageObjects: [],
            editSubscriptionMessage: {
                value: false,
                text: '',
                color: ''
            },
            responseErrors: {},
            deleteModal: false,
            showArchiveModal: false,
            editModal: false,
            editedSub: Object.assign({}, this.subscription),
            membershipCount: [
                {'value': 0, "text":  this.lang.until_canceled || 'Until canceled'}
            ],
            periodNames: [
                {value: 'Year', text: this.lang.year || 'Year'},
                {value: 'Month', text: this.lang.month || 'Month'},
                {value: 'Week', text: this.lang.week || 'Week'},
                {value: 'Day', text: this.lang.day || 'Day'}
            ]
        }
    },
    
    watch: {
        subscription: function(value) {
            this.subscription = value
            this.subscriptionReset = value
        }
    },
    created() {
        
        for(var i = 1; i <= 20; i++) {
            this.membershipCount.push({'value': i, 'text': (i + ' ' + (this.$page.props.lang.times || 'times'))})
        }

        this.editedSub.courses = this.courses_ids;
    },
    computed:{
        periodNameSelect() {
          return [
            { value: 'Day', text: this.lang.day || 'Day' },
            { value: 'Week', text: this.lang.week || 'Week' },
            { value: 'Month', text: this.lang.month || 'Month' },
            { value: 'Year', text: this.lang.year || 'Year' }        
          ]
      },
    },
    methods: {

        resetSubscription() {
            this.subscription = Object.assign({}, this.subscriptionReset)
            this.responseErrors = {}
        },
        editSubscription() {
            axios.put('/backoffice/subscriptions/update', this.editedSub)
                .then(response => {
                    if (response.data.status==="OK") {
                         this.editModal = false;
                         this.$inertia.reload({ only: ['subscription'] }); 
                         EventBus.$emit('SHOW_NOTIFICATION',{  
                            message: response.data.message,
                            color: 'success',
                            timeout: 5000
                        })
                    }
                })
                .catch(error => {
                        EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 5000
                        })
                    this.responseErrors = error.response.data.errors
                })
        },

        deleteSubscription() {
            axios.post('/backoffice/subscriptions/delete', {id: this.subscription.id})
                .then(response => {
                    var color = 'error';
                    if(response.data.status==="OK") {
                        var color = "success";
                        this.$inertia.visit('/backoffice/subscriptions', {method: 'get'})
                    }
                    EventBus.$emit('SHOW_NOTIFICATION',{  
                                message: response.data.message,
                                color: color,
                                timeout: 5000
                            })
                })
                .catch(function (error) {
                   EventBus.$emit('SHOW_NOTIFICATION',{  
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                })
            this.deleteModal = false
        },

        archive(){
            axios.post('/backoffice/subscriptions/archive', {id: this.subscription.id})
                .then(response => {
                    var color = 'error';
                    if(response.data.status==="OK") {
                        var color = 'success'
                        this.$inertia.visit('/backoffice/subscriptions/view/'+this.subscription.id, {method: 'get'})
                        this.showArchiveModal = false
                    }
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                                message: response.data.message,
                                color: color,
                                timeout: 10000
                            })
                })
                .catch(function (error) {
                    EventBus.$emit('SHOW_NOTIFICATION',{ 
                            message: error.response.data.message,
                            color: 'error',
                            timeout: 10000
                        })
                })
        },
    }
}
</script>
